import ProjectCard from "../../Components/ProjectCard";
import { useContext } from "react";
import { BlogsContext } from "../../utils/context";
import { variants } from "../../utils/animations";
import { motion } from "framer-motion";
import "./styles.css";

const Notebook = () => {
  const blogsData = useContext(BlogsContext);
  const blogs = blogsData.filter((v) => v.type === "notebook");

  return (
    <>
      <motion.div
        initial='hidden'
        whileInView='visible'
        variants={variants}
        className='notebook__container'
      >
        <motion.div variants={variants} className='notebook__title'>
          <motion.h1 variants={variants}>
            A space for my evolving thoughts, deep-dives and reflections.
          </motion.h1>

          <h3>NOTEBOOK</h3>
        </motion.div>

        {blogs?.map((item) => (
          <ProjectCard
            key={item.guid}
            title={item.title}
            thumbnail={item.thumbnail}
            description={item.description}
            content={item.content}
            timestamp={item.pubDate}
            subtitle={/(?:<.+?>)([^<>]*?)(?:<\/.*?>)/g.exec(item.content)[1]}
            width={"wide"}
          />
        ))}
      </motion.div>
    </>
  );
};

export default Notebook;
